import classNames from "classnames";
import { useEffect, useState } from "react";


const FormFieldError = ({name, errors, error, className="", style={}})=>{  
    return (
        <span className={"text-danger "+className} style={style}> 
            {errors && name ? errors[name]?.message : error ? error.message :  ''}
        </span>
    )
}

export default FormFieldError;